import { ReactElement } from 'react';
import classnames from 'classnames/bind';
import styles from './ButtonContainer.module.scss';

const cx = classnames.bind(styles);

interface ButtonContainerProps {
  left: ReactElement;
  right: ReactElement;
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  margin?: 'default' | 'none';
}

export const ButtonContainer = ({ left, right, direction = 'row', margin = 'default' }: ButtonContainerProps) => {
  const isColumn = direction === 'column' || direction === 'column-reverse';
  const isReversed = direction === 'row-reverse' || direction === 'column-reverse';
  const [first, second] = isReversed ? [right, left] : [left, right];

  return (
    <div
      className={cx('button-container', {
        'button-container-column': isColumn,
        'button-container-no-margin': margin === 'none',
      })}
    >
      {first}
      {second}
    </div>
  );
};
